<template>
  <Layout :tituloPagina="'Inicio Inventario'">
    <div class="row" v-show="!$store.state.todo.susargus">
      <div class="col-lg-12">
        <div class="card bg-warning text-white">
          <div class="card-body text-center">
            <p class="card-text">
              Su suscripción ha caducado, debe de pagar su mensualidad para seguir disfrutando de ArgusBlack, 
              visite la sección <a href="/sistema/cuenta/" style="color: red;">CUENTA</a> para renovarla en este momento.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xxl-6 col-lg-6 col-sm-6" v-if="tienePermiso('cmpSolicitudesInventario','componente') && widgets.WSolicitudes">
        <WSolicitudes :tienePermiso="tienePermiso"></WSolicitudes>
      </div>
      <div class="col-xxl-3 col-lg-3 col-sm-6" v-if="tienePermiso('cmpFamiliaInventario','componente') && widgets.WFamilia">
        <WFamilia></WFamilia>
      </div>
      <div class="col-xxl-3 col-lg-3 col-sm-6" v-if="tienePermiso('cmpArticuloInventario','componente') && widgets.WArticulo">
        <WArticulo></WArticulo>
      </div>
    </div>

    <div class="row">
      <div class="col-xxl-6" v-if="tienePermiso('cmpWEntradasRecientesInventarioInventario','componente') && widgets.WEntradasRecientesInventario">
        <WEntradasRecientesInventario></WEntradasRecientesInventario>
      </div>
      <div class="col-xxl-6" v-if="tienePermiso('cmpSalidasRecientesInventarioInventario','componente') && widgets.WSalidasRecientesInventario">
        <WSalidasRecientesInventario></WSalidasRecientesInventario>
      </div>
    </div>

    <div class="row">
      <div class="col-xxl-6" v-if="tienePermiso('cmpArticulosBajaInventario','componente') && widgets.WArticulosBaja">
        <WArticulosBaja></WArticulosBaja>
      </div>
      <div class="col-xxl-6" v-if="tienePermiso('cmpArticulosSinExistenciasInventario','componente') && widgets.WArticulosSinExistencias">
        <WArticulosSinExistencias></WArticulosSinExistencias>
      </div>
    </div>

    <widgets-visibles 
      ref="widgetsInventario"
      @actualizar-widgets="cargarAjustesWidgets()"
    ></widgets-visibles>
    <br>
  </Layout>
</template>

<script>
import UsuarioSrv from '@/services/UsuarioSrv.js'
import Layout from "@/views/layouts/main.vue"

import WSolicitudes             from './WSolicitudes.vue'
import WFamilia                 from './WFamilia.vue'
import WArticulo                from './WArticulo.vue'
import WEntradasRecientesInventario from './WEntradasRecientesInventario.vue'
import WSalidasRecientesInventario  from './WSalidasRecientesInventario.vue'
import WArticulosBaja           from './WArticulosBaja.vue'
import WArticulosSinExistencias from './WArticulosSinExistencias.vue'

import WidgetsVisibles from './WidgetsVisibles.vue'

import { todoGetters } from "@/state/helpers";

export default {
  name: 'Inicio',
  components: {
    Layout,
    WSolicitudes,
    WArticulosBaja,
    WArticulo,
    WFamilia,
    WEntradasRecientesInventario,
    WSalidasRecientesInventario,
    WArticulosSinExistencias,
    WidgetsVisibles
  },
  data() {
    return {
      widgets: {
        WSolicitudes: false,
        WArticulosBaja: false,
        WArticulo: false,
        WFamilia: false,
        WEntradasRecientesInventario: false,
        WSalidasRecientesInventario: false,
        WArticulosSinExistencias: false
      }
    }
  },
  created: function() {
    var self = this

    self.cargarAjustesWidgets()
  },
  computed: { ...todoGetters },
  methods: {    
    cargarAjustesWidgets: function() {
      var self = this
      var widgets = [
        'WSolicitudes','WArticulosBaja','WArticulo','WFamilia',
        'WEntradasRecientesInventario','WSalidasRecientesInventario',
        'WArticulosSinExistencias'
      ]
      UsuarioSrv.ajustesJSON(widgets).then(response => {
        let ajustes = response.data

        // Convertimos y asignamos cada valor al objeto widgets
        for (const key in ajustes) {
          if (self.widgets.hasOwnProperty(key)) {
            self.widgets[key] = ajustes[key] === '1'; // Convertimos a booleano
          }
        }
      }).catch(error => {
        let mensaje 
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar los ajustes del widgets'
        }
        console.log(error)
        iu.msg.error(mensaje)
      })
    }
  }
}
</script>